/* global axios */
// v124: privilégios do usuário logado (aba Privilégios da caixa) — espelho do
// backend (InboxPrivilegios) no filtro de TEMPO REAL das conversas.
// Cache em memória carregado no boot da tela de conversas (ConversationView),
// mesmo padrão do supervisorScope. Enquanto não carregar, o filtro realtime
// simplesmente NÃO ADICIONA nada (regra é aditiva; a listagem REST já vem
// filtrada certa do backend e não depende deste cache).
let regras = null;

export const loadMeusPrivilegios = async accountId => {
  try {
    const { data } = await axios.get(
      `/api/v1/accounts/${accountId}/privilegios/meus`
    );
    regras = data.regras || {};
  } catch (error) {
    // mantém o cache anterior (ou null = não adiciona nada)
  }
  return regras;
};

export const getMeusPrivilegios = () => regras;
